module.exports = __webpack_public_path__ + "img/modified_steps.7d527e1a.png";